export function debounce(func, wait) {
    var timeout;
    return function (...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
    };
}
export function debounceAsync(asyncFunc, wait) {
    const autoCancelFunc = autoCancel(asyncFunc);
    const waithandle = debounceTimer(wait);
    return async (...args) => {
        await waithandle();
        return await autoCancelFunc(...args);
    };
}
export function debounceTimer(wait) {
    var timeout;
    var cancel;
    return () => new Promise((resolve, reject) => {
        clearTimeout(timeout);
        if (cancel)
            cancel();
        cancel = reject;
        timeout = setTimeout(resolve, wait);
    });
}
;
export function autoCancel(asyncAction) {
    let request;
    return (...args) => {
        if (request)
            request.cancel();
        return (request = cancelable((signal) => asyncAction(signal, ...args)));
    };
}
export function cancelable(cb) {
    const controller = new AbortController();
    const { signal } = controller;
    const promise = cb(signal) || Promise.reject("Invalid Result");
    let cancel = null;
    let resolved = false;
    const result = new Promise((resolve, reject) => promise.then((...args) => { resolved = true; return resolve(...args); }, (cancel = reject)));
    result.cancel = () => {
        if (!resolved) {
            controller.abort();
            cancel("Promise Canceled");
        }
    };
    return result;
}
